import Swal from 'sweetalert2';

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import StatsCore from '../icons/statscore.svg';

import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed.js';

export default class Amazon extends Plugin {
  static get requires() {
    return [MediaEmbed];
  }

  init() {
    const editor = this.editor;

    editor.ui.componentFactory.add('statsCore', (locale) => {
      const view = new ButtonView(locale);

      view.set({
        label: 'StatsCore',
        icon: StatsCore,
        tooltip: true,
      });

      view.on('execute', async () => {
        const { value: formValues } = await Swal.fire({
          title: 'Preencha os dados',
          html: `
            <input id="swal-input-id" class="swal2-input" placeholder="Coloque o ID statscore">
            <input id="swal-input-title" class="swal2-input" placeholder="Coloque o título">
          `,
          focusConfirm: false,
          confirmButtonText: 'OK',
          preConfirm: () => {
            const id = document.getElementById('swal-input-id').value;
            const title = document.getElementById('swal-input-title').value;

            if (!id || !title) {
              Swal.showValidationMessage('Por favor, preencha todos os campos');
              return false;
            }

            return { id, title };
          },
        });

        if (formValues) {
          editor.model.change(() => {
            const content = ` <p>[template="embed-statscore" id="${formValues.id}" title="${formValues.title}"]</p>`;

            const viewFragment = editor.data.processor.toView(content);
            const modelFragment = editor.data.toModel(viewFragment);

            editor.model.insertContent(
              modelFragment,
              editor.model.document.selection
            );
          });
        }
      });

      return view;
    });
  }
}
